import React, { memo, forwardRef } from "react";
const SvgNu = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.267 22.296a1 1 0 01-.943-.666l-3.851-10.864a1 1 0 01.942-1.334h.05a1 1 0 01.948.682l2.099 6.254c.128.384.288.84.48 1.368.192.528.368 1.048.528 1.56.176.496.304.904.384 1.224H16c.912-1.008 1.624-2.064 2.136-3.168a13.45 13.45 0 001.104-3.624c.175-1.025.282-2.124.32-3.296.018-.552.464-1 1.016-1h.088a.973.973 0 01.982 1 23.333 23.333 0 01-.414 3.704 15.526 15.526 0 01-1.488 4.176c-.633 1.222-1.503 2.444-2.61 3.666a.978.978 0 01-.727.318h-1.14z"
      />
    </svg>
  );
});
SvgNu.displayName = "SvgNu";
const MemoForwardRef = memo(SvgNu);
export default MemoForwardRef;
